import { ErrorMessage } from './ErrorMessage';
import { Field } from './Field';
import { Input } from './Input';
import { Label } from './Label';
import { Selects } from './Select';
import { TextFields } from './Textfield';
import { Mask } from './Mask';
import { MandatoryIcon } from './MandatoryIcon';
import { InputFile } from './InputFile';
import AutoCompleteSelect from './AutoCompleteSelect';
import MultiSelect from './MultiSelect';
import NumericInput from './NumericInput';
import { CheckBox } from './Checkbox';

export const Form = {
    Label,
    Input,
    ErrorMessage,
    Field,
    Selects,
    TextFields,
    Mask,
    AutoCompleteSelect,
    MultiSelect,
    MandatoryIcon,
    InputFile,
    NumericInput,
    CheckBox
};
